/** Вход, регистрация и стъпката с код за потвърждение по имейл. */
export default {
  tabs: {
    signIn: "Вход",
    signUp: "Регистрация",
  },
  signIn: {
    title: "Добре дошли отново",
    subtitle: "Влезте, за да управлявате профила и генерираните си материали.",
    submit: "Вход",
  },
  signUp: {
    title: "Създайте своя профил",
    subtitle: "Получавате 10 безплатни точки, за да започнете – без карта и без да бъдете таксувани, освен ако сами не купите пакет точки.",
    submit: "Създайте профил",
    acceptTerms: "Потвърждавам, че съм навършил(а) 18 години и приемам <terms>Общите условия</terms> и <privacy>Политиката за поверителност</privacy>.",
  },
  fields: {
    fullName: "Име и фамилия",
    fullNamePlaceholder: "Вашето име",
    email: "Имейл",
    emailPlaceholder: "you@example.com",
    password: "Парола",
    confirmPassword: "Потвърдете паролата",
  },
  forgot: {
    link: "Забравена парола?",
    title: "Нова парола",
    subtitle: "Въведете имейла на профила си. Ако го открием, ще изпратим връзка, с която да изберете нова парола.",
    submit: "Изпратете връзка",
    sent: "Ако има профил за {{email}}, изпратихме връзка за нова парола. Тя е валидна {{minutes}} минути и може да се използва само веднъж. Проверете входящата си поща и папката за спам.",
    backToSignIn: "← Обратно към входа",
  },
  reset: {
    title: "Изберете нова парола",
    subtitle: "Тази връзка е валидна {{minutes}} минути след изпращането и може да се използва само веднъж.",
    submit: "Запазете новата парола",
    mismatch: "Двете пароли не съвпадат.",
    expired: "Тази връзка е невалидна или е изтекла. Поискайте нова от страницата за вход.",
    requestNew: "Поискайте нова връзка",
    missing: "Тази връзка е непълна. Поискайте нова от страницата за вход.",
  },
  verify: {
    title: "Проверете имейла си",
    intro: "Въведете 6-цифрения код, който изпратихме на <email>{{email}}</email>. Той е валиден 10 минути.",
    codeLabel: "Код за потвърждение",
    submit: "Потвърдете и създайте профил",
    verifying: "Потвърждаване…",
    useDifferentEmail: "← Използвайте друг имейл",
    resend: "Изпратете нов код",
    resendIn: "Нов код след {{seconds}} сек.",
    codeSent: "Изпратихме 6-цифрен код на {{email}}.",
    newCodeSent: "Изпратихме нов код на {{email}}.",
    resendFailed: "Не успяхме да изпратим нов код.",
    digitLabel: "Цифра {{position}} от {{length}}",
  },
  password: {
    rules: {
      length: "Поне {{min}} знака",
      letter: "Поне една буква",
      number: "Поне една цифра",
      personal: "Без вашето име, имейл или често срещана парола",
    },
    problems: {
      tooShort: "Паролата трябва да е поне {{min}} знака.",
      tooLong: "Паролата може да е най-много {{max}} знака.",
      needsLetter: "Паролата трябва да съдържа поне една буква.",
      needsNumber: "Паролата трябва да съдържа поне една цифра.",
      containsPersonal: "Паролата не трябва да съдържа вашето име или имейл адрес.",
      tooCommon: "Тази парола е твърде често срещана и лесна за отгатване. Моля, изберете по-надеждна.",
    },
  },
  bonus: {
    title: "Добре дошли! Точките ви ви очакват",
    body_one: "{{points}} точки от предишната ви покупка вече са в профила ви.",
    body_other: "{{points}} точки от {{count}} ваши предишни покупки вече са в профила ви.",
    note: "Добавени са, когато сте платили с този имейл адрес. Заедно с 10-те безплатни точки можете да започнете веднага.",
    cta: "Започнете да генерирате",
    close: "Затвори",
  },
  errors: {
    acceptTerms: "Моля, потвърдете, че сте навършили 18 години и приемате Общите условия.",
    fullNameRequired: "Моля, въведете име и фамилия.",
  },
};
